import React, { useEffect, useState } from 'react';

const STATUS_API = (import.meta.env.VITE_STATUS_API_ORIGIN || 'https://fair-corp.com').replace(/\/$/, '') + '/api/status';
const ROTATE_MS = 9000;
const POLL_MS = 60_000;

interface Banner {
  id: string;
  message: string;
  severity: 'info' | 'warning' | 'error';
  visible: boolean;
  order: number;
}

const severityStyles: Record<string, string> = {
  info: 'bg-primary-900/40 border-primary-700/50 text-primary-200',
  warning: 'bg-amber-900/40 border-amber-700/50 text-amber-200',
  error: 'bg-red-900/40 border-red-700/50 text-red-200',
};

const StatusBanner: React.FC = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const load = () => {
      fetch(STATUS_API)
        .then((r) => r.ok ? r.json() : null)
        .then((s) => {
          const visible = (s?.banners ?? []).filter((b: Banner) => b.visible).sort((a: Banner, b: Banner) => a.order - b.order);
          setBanners(visible);
          setIndex(0);
        })
        .catch(() => setBanners([]));
    };
    load();
    const poll = setInterval(load, POLL_MS);
    return () => clearInterval(poll);
  }, []);

  useEffect(() => {
    if (banners.length <= 1) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % banners.length), ROTATE_MS);
    return () => clearInterval(t);
  }, [banners.length]);

  if (banners.length === 0) return null;

  const current = banners[index];
  const style = severityStyles[current.severity] ?? severityStyles.info;

  return (
    <div className={`w-full border-b px-4 py-2.5 text-center text-sm font-medium ${style}`} role="alert" aria-live="polite">
      {current.message}
    </div>
  );
};

export default StatusBanner;
